import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import Router from 'next/router'

import DesktopContainer from '~/components/DesktopContainer'
import Spacer from '~/components/Spacer'
import PayTicketsButton from "~/components/LockButton"
import { PARKING_FLOW_TYPE } from "~/utilities/constants"

const AdditionalTicketsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const AdditionalTicketsText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  color: ${props => props.theme.colors.menuItem};
  font-size: ${props => (props.isMobile ? "1.875rem" : "2.1875rem")};
  font-weight: bold;
  text-align: center;
`

const SubText = styled.div`
  color: ${props => props.theme.colors.text.label};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  max-width: 370px;
  width: 100%;
`
@inject(all => ({
  isMobile: all.store.ui.isMobile,
  payableSelectableCount: all.store.parkingFlow.results.payableSelectableCount,
  fightableSelectableCount: all.store.parkingFlow.results.fightableSelectableCount,
  type: all.store.parkingFlow.flow.type,
  totalFightableSelectableOwed: all.store.parkingFlow.results.totalFightableSelectableOwed,
  totalPayableSelectableOwed: all.store.parkingFlow.results.totalPayableSelectableOwed
}))
@observer
class TicketToFight extends React.Component {
  render() {
    const {
      payableSelectableCount,
      fightableSelectableCount,
      type,
      totalFightableSelectableOwed,
      totalPayableSelectableOwed
    } = this.props
    const remainingTickets = type === PARKING_FLOW_TYPE.fight ? fightableSelectableCount : payableSelectableCount
    const alternateRemaining = type === PARKING_FLOW_TYPE.fight ? payableSelectableCount : fightableSelectableCount
    let displayType
    if(remainingTickets) {
      displayType = type;
    } else {
      displayType = PARKING_FLOW_TYPE.fight === type ? PARKING_FLOW_TYPE.pay : PARKING_FLOW_TYPE.fight
    }
    const moreThanOneViolation = (remainingTickets || alternateRemaining) > 1
    const displayText = moreThanOneViolation ? 'tickets' : 'ticket'
    const violationText = moreThanOneViolation ? 'violations' : 'violation'
    const displayAmount = displayType === PARKING_FLOW_TYPE.fight
    ? totalFightableSelectableOwed
    : totalPayableSelectableOwed

    let actionName
    let actionColor
    if (displayType === PARKING_FLOW_TYPE.fight) {
      actionColor = "green"
      actionName = "Fight"
    }
    if (displayType === PARKING_FLOW_TYPE.pay) {
      actionColor = "red"
      actionName = "Pay"
    }
    return (
      <DesktopContainer>
        <AdditionalTicketsContainer>
          <AdditionalTicketsText>
            {`You can still ${displayType} ${remainingTickets || alternateRemaining} ${displayText}`}
          </AdditionalTicketsText>
          <Spacer mobile={30} desktop={21} />
          <SubText>
            You have {remainingTickets || alternateRemaining} {violationText}
            {' '}with fines totaling ${displayAmount}
          </SubText>
          <Spacer mobile={30} desktop={45} />
          <PayTicketsButton
            color={actionColor}
            onClick={() => {
              Router.push("/parking/results")
            }}
            text={`${actionName} my tickets`}
          />
        </AdditionalTicketsContainer>
        <Spacer mobile={30} desktop={20} />
      </DesktopContainer>
    )
  }
}

export default TicketToFight
